import React from 'react';
// Components:
import AgreeBlock from '../../../../../components/AgreeBlock';
import Agreement from './Agreement';

type AgreeBlockContainerProps = {
  className?: string;
  ofertaText: string | null;
};
export const AgreeBlockContainer = ({
  className,
  ofertaText,
}: AgreeBlockContainerProps) => (
  <AgreeBlock className={className}>
    <Agreement ofertaText={ofertaText} />
  </AgreeBlock>
);
